import store from "@/Redux/Store";
import { updateDomainCart } from "../../../Redux/Actions";
import { getAuthToken } from "../../../Utils/authToken";
import LocalStorageHelper from "../../../Utils/LocalStorageHelper";

export const updateCartPrices = (oldcart, newCartItems) => {
  const totalAmount = newCartItems?.reduce((acc, current) => {
    return acc + current?.price;
  }, 0);

  const totalDiscount = newCartItems?.reduce((acc, current) => {
    return acc + current?.discounted_price;
  }, 0);

  return {
    cart: {
      ...oldcart,
      amount: totalAmount,
      discounted_amount: totalDiscount,
      items: newCartItems,
    },
  };
};

export const sendUpdatedCartData = (payload, setLocalCartData, setLoading, dispatch) => {
  // If user is logged in , then send the new payload to server, if response is success then update the state.
  if (getAuthToken()) {
    setLoading(true);
    dispatch(
      updateDomainCart(payload, (status) => {
        if (status) {
          setLocalCartData(payload.cart);
        }
        setLoading(false);
      }),
    );
  } else {
    // In case of non signed-in user, simply update localstorage and state.
    setLocalCartData(payload.cart);
    LocalStorageHelper.add("domainCart", payload.cart);
  }
};

export const calculateDomainRenewalPrice = (price, renewalPrice, year) => {
  return price + renewalPrice * (year - 1);
};

export const getUpdatedDomainPrice = (domain, year) => {
  const { purchase_per_year_price, renewal_per_year_price } = domain?.data;
  const updatedPrice = calculateDomainRenewalPrice(purchase_per_year_price, renewal_per_year_price, year);

  // As per current business requirement, both price and discounted price will be updated using same key 'purchase_per_year_price', however if in future we separate the keys then logic will be updated.
  return {
    ...domain,
    price: updatedPrice,
    discounted_price: updatedPrice,
    data: { ...domain?.data, year: year },
  };
};

export const getHelplineNumber = () => {
  const ds_helpline_number = store?.getState()?.commonReducer?.appConstants?.ds_helpline_number;
  return ds_helpline_number;
};
